import { WidgetPropertyKeys, OneOfElementPropertyKeys, IMediaAsset } from './index';
import { IColor } from './color';
import { IFontStyle } from './font';
import { IFeed, IFeedData } from './feed';
import { IElementViewNode, NodeKind, IElementDataNode } from './nodes';
import { Widget } from '../creative/elements/widget/widget';
import { IElementProperty } from './creativeset/element';

export interface IWidgetElementDataNode extends IElementDataNode<NodeKind.Widget> {
    html: string;
    js: string;
    ts: string;
    css: string;
    customProperties: IWidgetCustomProperty[];
    parentId?: string;
    widgetReference?: string;
    __widget?: Widget;
}

export interface IWidgetViewElement extends IElementViewNode<NodeKind.Widget> {
    customProperties?: IWidgetCustomProperty[];
    parentId?: string;
}

// New interface
export interface IWidgetElementProperty extends Omit<IElementProperty, 'value'> {
    name: OneOfElementPropertyKeys | WidgetPropertyKeys | string;
    value?: OneOfCustomPropertyValue;
    unit?: WidgetUnits;
}

export interface IWidgetImage extends Omit<IMediaAsset, 'width' | 'height'> {}

export type OneOfCustomPropertyValue =
    | string
    | number
    | boolean
    | IWidgetSelectOption[]
    | IColor
    | IFontStyle
    | IWidgetImage
    | IFeed;

export interface IWidgetCustomProperty {
    name: string;
    label: string;
    value?: OneOfCustomPropertyValue;
    unit: WidgetUnits;
    versionPropertyId?: string;
    clientId?: string;
}

export type WidgetCustomProperties = keyof IWidgetCustomProperty;

export interface IWidgetSelectOption {
    value: string;
    selected: boolean;
}

export type WidgetUnits =
    | 'number'
    | 'boolean'
    | 'select'
    | 'text'
    | 'color'
    | 'font'
    | 'feed'
    | 'image';

export interface IFeedHelper {
    id: string;
    /**
     * Returns a promise which resolves with FeedData
     */
    load: () => Promise<IFeedData>;
    data: IFeedData;
    loaded: boolean;
    change: (callback: FeedHelperCallback) => void;
}

export type FeedHelperCallback = (feedData: IFeedData) => void;

export const WIDGET_PROPERTY_PREFIX = 'custom:';

export interface IWidgetMousePositionEvent {
    x: number;
    y: number;
    // This was added since when the position from the mouse event inside an iframe is always relative to said iframe
    // We want to have the correct data (relative to the creative) for heatmaps
    translatedX: number;
    translatedY: number;
}
